import React, { useState } from 'react'
import { Box, Grid, Divider, List, Link } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import meta from '../../../Assets/img/socials/meta.png';
import linkedin from '../../../Assets/img/socials/linkedin.png';
import twitter from '../../../Assets/img/socials/x.png';
import youtube from '../../../Assets/img/socials/youtube.png';
import HeaderCompo from '../../../Components/HeaderComp/HeaderCompo';
import { enqueueSnackbar } from 'notistack';
import logo from '../../../Assets/img/logodetails.png'
import dayjs from "dayjs";
import { CorrectState } from './MapList';
import { useScrollToHash } from '../../../Hooks/useScrollToHash';
import NewMap from './NewMap';

function Summary({ summaryData, id }) {

  const [isViewEmail, setIsViewEmail] = useState({})
  const [isViewEmail1, setIsViewEmail1] = useState({})

  const textStyles = 'text-[#004878] text-md ';

  const renderParagraphPair = (label, text) => (
    <Box sx={{ display: 'flex', gap: 2, mb: 0.5 }}>
      <ParagraphComp text={label} className={`${textStyles} w-[130px] font-bold`} />
      <ParagraphComp text={text} className={`${textStyles} font-normal`} />
    </Box>
  );

  const renderSocial = (icon, title, link) => (
    <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
      <img src={icon} className='w-[25px] h-[25px]' style={{ borderRadius: '50%' }} alt='socials' />
      <Link href={link} target='_blank'>{title || '-'}</Link>
    </Box>
  );
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };


  useScrollToHash();


  const token = localStorage.getItem('NpoToken')


  const viewEmail = (email) => {
    if (token) {
      setIsViewEmail((prev) => ({
        ...isViewEmail,
        [email]: prev[email] ? false : true, // Toggles the value between true and false
      }));
    } else {
      enqueueSnackbar('Please register or log in to view email', { variant: 'error' });
    }

  };
  const viewEmail1 = (email) => {
    if (token) {
      setIsViewEmail1((prev) => ({
        ...isViewEmail1,
        [email]: prev[email] ? false : true, // Toggles the value between true and false
      }));
    } else {
      enqueueSnackbar('Please register or log in to view email', { variant: 'error' });
    }

  };

  const convertEmail = (email) => {
    return email.replace(/@/g, '(at)').replace(/\./g, '[dot]');
  };

  const scrollToSection = () => {
    document.getElementById("involved")?.scrollIntoView({ behavior: "smooth" });
  };

  const appearSeals = [
    'Platinum',
    'Silver',
    'Bronze',
    'Bronze under review for higher certification',
    'Gold'
  ];

  const registrationData = Array.isArray(summaryData?.registration_as)
    ? summaryData.registration_as
    : [summaryData?.registration_as].filter(Boolean);



  return (
    <>
      {summaryData ?
        <div id={id} >
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={9}>
              <Box sx={{ marginBottom: '30px' }}>
                <Grid sx={{ height: '40px', backgroundColor: '#004878', marginBottom: '0px', justifyContent: 'space-around', display: 'flex', gap: '20px', alignItems: 'center' }} >
                  <ParagraphComp onClick={() => { handleScroll('Causes') }} text='Summary' className='text-[white] hover:underline hover:text-[#dedada] transition-[2s] cursor-pointer text-xl font-normal' />
                  <ParagraphComp onClick={() => { handleScroll('ProgramsAndResults') }} text='Programmes & Results' className='text-[white] hover:text-[#dedada] hover:underline transition-[2s] cursor-pointer text-xl font-normal' />
                  <ParagraphComp onClick={() => { handleScroll('Governance') }} text='Governance' className='text-[white] cursor-pointer hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal' />
                  <ParagraphComp onClick={() => { handleScroll('Financial') }} text='Financials' className='text-[white] cursor-pointer hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal' />
                  <ParagraphComp onClick={() => { handleScroll('Operations') }} text='Operations' className='text-[white] cursor-pointer hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal' />
                  <ParagraphComp onClick={scrollToSection} text='Get Involved' className='text-[white] cursor-pointer hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal' />
                </Grid>
                <Grid container xs={12} >
                  <Grid xs={6}>
                    <ParagraphComp text='*SOURCE: Self-reported by organisation' className='text-[black] font-light text-md italic  ' />
                  </Grid>
                  <Grid xs={6}>
                    <ParagraphComp text='Last updated on:' className='text-[black] font-light text-md italic  ' />
                  </Grid>
                </Grid>
              </Box>
              <Grid container spacing={2} xs={12}>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      overflow: 'hidden',
                      height: '200px', // Set height explicitly for consistency
                      borderRadius: '8px',
                    }}
                  >
                    {summaryData?.logo ?
                      <img
                        src={`data:image/png;base64,${summaryData?.logo}`}
                        alt="logo"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain', // Ensures the image fits within the box
                          borderRadius: '8px',
                        }}
                      /> : <img
                        src={logo}
                        alt="logo"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain', // Ensures the image fits within the box
                          borderRadius: '8px',
                        }}
                      />}
                  </Box>
                </Grid>
                <Grid item xs={9}>

                  {/* {renderParagraphPair('Also known as:', `${summaryData?.also_known_as||'-'}| City/ Town/ Taluka/ Village, District, State* : ${summaryData?.reg_city||'-'},  ${summaryData?.cor_district||'-'},  ${summaryData?.cor_state||'-'}` || '-')} */}
                  <Box sx={{ display: 'flex', gap: 2, mb: .5, }}>
                    <ParagraphComp text='Also known as:' className='text-[#004878]  text-md font-bold' />
                    <ParagraphComp text={summaryData?.also_known_as || '-'} className='text-[#004878] text-md font-normal' />
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, mb: .5, }}>
                    <ParagraphComp text='Formerly known as:' className='text-[#004878]  text-md font-bold' />
                    <ParagraphComp text={summaryData?.former_name || '-'} className='text-[#004878] text-md font-normal' />
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, mb: .5, }}>
                    <ParagraphComp text='City/ Town/ Taluka/ Village, District, State of Main Office :' className='text-[#004878]  text-md font-bold' />
                    <ParagraphComp text={`${summaryData?.city || '-'},  ${summaryData?.district || '-'},  ${summaryData?.state || '-'}`} className='text-[#004878] text-md font-normal' />
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, mb: .5, }}>
                    <ParagraphComp text='Works pan India:' className='text-[#004878]  text-md font-bold' />
                    <ParagraphComp text={summaryData?.pan_india || '-'} className='text-[#004878] text-md font-normal' />
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                    <ParagraphComp text='Registered as:' className='text-[#004878] text-md font-bold' />
                    <ParagraphComp
                      text={registrationData.map(item => item.sub_data).join(', ') || '-'}
                      className="text-[#004878] text-md font-normal"
                    />                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                    <ParagraphComp text='Registered in the year:' className='text-[#004878] text-md font-bold' />
                    <ParagraphComp text={summaryData?.registration_year || '-'} className='text-[#004878] text-md font-normal' />
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                    <ParagraphComp text='Slogan/ Tag line:' className='text-[#004878] text-md font-bold' />
                    <ParagraphComp text={summaryData?.slogan || '-'} className='text-[#004878] text-md font-normal' />
                  </Box>
                </Grid>
              </Grid>
              <Box>

                {/* <Box sx={{ paddingTop: '20px' }} >
                  <ParagraphComp text='*Details of Correspondence/ Main Office address' className='text-[black] italic font-thin text-md' />
                </Box> */}
                {/* <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                  <ParagraphComp text='Profile Completion Status' className='text-[#004878] text-md font-bold' />
                  <ParagraphComp text={summaryData?.completion_status} className='text-[#004878] text-md font-normal' />
                </Box> */}
                <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                  <ParagraphComp text='Profile Last Updated by NPO' className='text-[#004878] text-md font-bold ' />
                  <ParagraphComp text={summaryData?.last_updated_date ? `${dayjs(summaryData?.last_updated_date).format("DD-MM-YYYY") || "-"}` : '-' || '-'} className='text-[#004878] text-md font-normal' />
                  {/* <ParagraphComp text={`${new Date(summaryData?.last_updated_date) || "-"}`|| '-'} className='text-[#004878] text-md font-normal' /> */}
                </Box>
                <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                  <ParagraphComp text='Get Involved' className='text-[#d0353c] text-md font-bold cursor-pointer' onClick={scrollToSection} />
                  <ParagraphComp text={summaryData?.get_involved || '-'} className='text-[#004878] text-md font-normal' />
                </Box>

                <Grid container spacing={2} sx={{ mt: 2 }}>

                  <Grid item xs={4}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ display: 'flex', gap: 1, mb: .5, mt: 1.5 }}>
                      <ParagraphComp text={`Expenditure in FY ${summaryData?.annual_expenditure_fy}:`} className='text-[#004878] text-md font-bold' />
                      <ParagraphComp
                        text={`₹ ${(summaryData?.annual_expenditure && !isNaN(summaryData.annual_expenditure))
                          ? parseFloat(summaryData.annual_expenditure).toLocaleString('en-IN', { maximumFractionDigits: 2 })
                          : '-'}`}
                        className='text-[#004878] text-md font-normal'
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                      <ParagraphComp text='Total full-time paid Staff:' className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={`${summaryData?.full_time_paid_staff || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ display: 'flex', gap: 1, mb: .5, mt: 1.5 }}>
                      <ParagraphComp
                        text={`Assets as of FY ${summaryData?.assets_fy || ''}:`}
                        className='text-[#004878] text-md font-bold'
                      />
                      <ParagraphComp
                        text={`₹ ${(summaryData?.assets && !isNaN(summaryData.assets))
                          ? parseFloat(summaryData.assets).toLocaleString('en-IN', { maximumFractionDigits: 2 })
                          : '-'}`}
                        className='text-[#004878] text-md font-normal'
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, mb: .5 }}>
                      <ParagraphComp text='Total full-time pro-bono Volunteers:' className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={summaryData?.pro_brono_volunteers || '-'} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ display: 'flex', gap: 2, mb: .5, mt: 1.5 }}>
                      <ParagraphComp text='Lives/ entities impacted so for:' className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={summaryData?.total_lives_changed || '-'} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={4}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ mb: .5, mt: 1.5 }}>
                      <ParagraphComp text={`Tax Exemption under ${summaryData?.exemption_type || '-'}`} className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={`Valid till: ${summaryData?.exemption_valid_till || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ mb: .5, mt: 1.5 }}>
                      <ParagraphComp text={`Deduction to Indian taxpayers under ${summaryData?.deduction_type || '-'}`} className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={`Valid till: ${summaryData?.deduction_valid_till || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ mb: .5, mt: 1.5 }}>
                      <ParagraphComp text={`Eligibility to receive foreign contributions`} className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={`Valid till: ${summaryData?.foreign_valid_till || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={6}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ mb: .5, mt: 1.5 }}>
                      <ParagraphComp text={`Organisation is registered with Ministry of Corporate Affairs for CSR`} className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={`${summaryData?.csr_fund_registration || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid>
                  {/* <Grid item xs={8}>
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <Box sx={{ mb: .5, mt: 1.5 }}>
                      <ParagraphComp text={`Remarks`} className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={`${summaryData?.remarks || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Grid> */}
                  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'start', marginTop: '20px', color: '#E5E8EB', borderBottomWidth: 3, flexDirection: 'column', gap: '5px' }}>
                    <ParagraphComp text={`SOURCE: Self-reported by organisation`} className='text-[black] italic text-md font-thin' />
                    <ParagraphComp text={`Please check the respective government site for eligibility and validity as on date.`} className='text-[black] italic text-md font-thin' />
                  </Box>
                  <Box sx={{ marginTop: '20px' }}>
                  </Box>
                </Grid>
              </Box>

            </Grid>

            <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }} xs={3}>
              <Box sx={{ backgroundColor: 'white', borderRadius: '16px', border: '1px solid grey', padding: '16px' }}>
                <HeaderCompo className='text-2xl font-bold text-[#004878] text-center' tagType='h3' text='Trust and Transparency Indicator' />
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', }}>
                  <img src={`data:image/png;base64,${summaryData?.trust_and_transparency_logo}`} width={242} height={211} style={{ borderRadius: 12 }} alt='logo' />
                </Box>
                {appearSeals.includes(summaryData?.trust_and_transparency_level) &&

                  <Box sx={{ display: 'flex', gap: 2, mb: .5, mt: 3 }}>
                    <Box sx={{ width: '25%' }}>
                      <ParagraphComp text='Valid till' className='text-[#004878] text-md font-bold w-30' />
                    </Box>
                    <ParagraphComp text={`: ${(summaryData?.level !== 'Basic' || 'Entry') ? dayjs(summaryData?.valid_till).format("DD-MM-YYYY") : '-' || '-'}`} className='text-[#004878] text-md font-normal' />
                  </Box>
                }

                {/* {appearSeals.includes(summaryData?.trust_and_transparency_level)  &&<Box sx={{ display: 'flex', gap: 2, mb: .5, mt: 3 }}>
                  <Box sx={{ width: '25%' }}>
                    <ParagraphComp text='Tax Exempt Under' className='text-[#004878] text-md font-bold w-30' />
                  </Box>
                  <ParagraphComp text={`: ${summaryData?.exemption_type || '-'}`} className='text-[#004878] text-md font-normal' />
                </Box>} */}
                {appearSeals.includes(summaryData?.trust_and_transparency_level) && summaryData?.provisional !== 'No' && <Box sx={{ display: 'flex', gap: 2, mb: .5, mt: 3 }}>
                  <Box sx={{ width: '25%' }}>
                    <ParagraphComp text='Provisional' className='text-[#004878] text-md font-bold w-30' />
                  </Box>
                  <ParagraphComp text={`: ${summaryData?.provisional || '-'}`} className='text-[#004878] text-md font-normal' />
                </Box>}
                {/* {appearSeals.includes(summaryData?.trust_and_transparency_level)  &&<Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                  <Box sx={{ width: '25%' }}>
                    <ParagraphComp text='Status' className='text-[#004878] text-md font-bold w-30' />
                  </Box>
                  <ParagraphComp text={`: ${summaryData?.exemption_status || '-'}`} className='text-[#004878] text-md font-normal' />
                </Box>} */}
                {summaryData?.remarks && (
                  <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                    <Box sx={{ width: '25%' }}>
                      <ParagraphComp text='Remarks' className='text-[#004878] text-md font-bold' />
                    </Box>
                    <Box sx={{ display: 'flex', width: '70%', gap: '2px' }}>
                      <ParagraphComp text={`:`} className='text-[#004878] text-md font-normal' />
                      <ParagraphComp text={`${summaryData?.remarks || '-'}`} className='text-[#004878] text-md font-normal ' />
                    </Box>
                  </Box>
                )}

              </Box>
              <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px' }}>
                <ParagraphComp text='Certification History' className='text-[#004878] text-md font-bold' />
                {/* {summaryData?.certification_history && summaryData?.certification_history.length > 0 ? */}
                {summaryData?.certification_history?.length > 0 ?
                  summaryData.certification_history
                    .sort((a, b) => {
                      const [startA] = a?.financial_year_under_review?.split('-').map(Number);
                      const [startB] = b?.financial_year_under_review?.split('-').map(Number);

                      // Sort by start year in ascending order
                      return startA - startB;
                    })
                    .map((history, index) => (
                      <Box sx={{ display: 'flex', mt: 2 }} key={index}>
                        {history?.financial_year_under_review || history?.certification_level_awarded ? (
                          <>
                            <ParagraphComp
                              text={`${history?.financial_year_under_review || '-'}`}
                              className="text-[#004878] text-md font-bold w-40"
                            />
                            <ParagraphComp
                              text={`: ${history?.certification_level_awarded || '-'}`}
                              className="text-[#004878] text-md font-normal"
                            />
                          </>
                        ) : (
                          '-'
                        )}
                      </Box>
                    ))
                  : <>
                    <ParagraphComp
                      text={'-'}
                      className="text-[#004878] text-md font-bold w-40"
                    />
                  </>}

              </Box>

            </Grid>



            <Grid item xs={12} id="Causes">
              <Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={6}>
                  <Box sx={{ backgroundColor: '#004878', padding: '10px', borderRadius: '15px', width: '100%', display: 'flex', alignItems: 'center' }}>
                    <ParagraphComp text='Summary' className='text-[white] mt-[0px] mb-[0px] text-2xl  font-bold' />
                  </Box>
                </Grid>
              </Grid>
              <Grid sx={{ marginTop: '30px', display: 'flex', gap: '20px', flexWrap: 'wrap' }} xs={12} >
                <Grid xs={5.85} sx={{ height: 'auto' }} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    <ParagraphComp text='Causes' className='text-[#004878] leading-tight text-md font-bold' />
                    <ParagraphComp text='(based on international classification of NPOs)' className='text-[#004878] text-md font-normal mt-[2px]' />

                    {summaryData?.causes?.length > 0 && Array.isArray(summaryData?.causes) ? (
                      <List>
                        {summaryData?.causes?.map((item, index) => (
                          <ParagraphComp key={index} text={item.data ? `${index + 1}. ${item.data}` : ''} className="text-[#004878] text-md" />
                        ))}
                      </List>
                    ) : '-'}
                  </Box>
                </Grid>


                <Grid xs={5.85} sx={{ height: 'auto' }} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    <ParagraphComp text='Work towards UN Sustainable Development Goals ' className='text-[#004878] text-md font-bold' />
                    {summaryData?.sustainable_developement || summaryData?.sustainable_developement?.length > 0 ?
                      <List>
                        {summaryData?.sustainable_developement?.includes(",")
                          ? summaryData?.sustainable_developement?.split(", ").map((item, i) =>
                            <ParagraphComp text={`${i + 1} . ${item}`} className="text-[#004878] text-md" />
                          )
                          : <ParagraphComp text={`1. ${summaryData?.sustainable_developement}`} className="text-[#004878] text-md" />
                        }
                      </List>
                      : ''}
                  </Box>
                </Grid>

                <Grid xs={5.85} sx={{ height: 'auto' }} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    <ParagraphComp text='Nature of Intervention ' className='text-[#004878] text-md font-bold' />
                    {summaryData?.nature_of_intervention || summaryData?.sustainable_developement?.length > 0 ?
                      <List>
                        {summaryData?.nature_of_intervention?.includes(",")
                          ? summaryData?.nature_of_intervention?.split(", ").map((item, i) =>
                            <ParagraphComp text={`${i + 1} . ${item}`} className="text-[#004878] text-md" />
                          )
                          : <ParagraphComp text={summaryData?.nature_of_intervention ? `1. ${summaryData?.nature_of_intervention}` : ''} className="text-[#004878] text-md" />
                        }
                      </List>
                      : ''}
                  </Box>
                </Grid>


                <Grid xs={5.85} sx={{ height: 'auto' }} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    <ParagraphComp text='Populations / Segments Served' className='text-[#004878] text-md font-bold' />
                    {[summaryData?.segment_served].length > 0 && summaryData?.segment_served != null ?
                      <List>
                        {summaryData?.segment_served?.includes(",")
                          ? summaryData?.segment_served?.split(", ").map((item, i) =>
                            <ParagraphComp text={`${i + 1} . ${item}`} className="text-[#004878] text-md" />
                          )
                          : <ParagraphComp text={`1. ${summaryData?.segment_served}`} className="text-[#004878] text-md" />
                        }
                      </List>
                      :
                      ''}
                  </Box>
                </Grid>
              </Grid >
              <Grid item xs={12} sx={{ marginTop: '30px', display: 'flex', gap: '20px' }}>
                <Grid item xs={4} sx={{ height: 'auto' }} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    <ParagraphComp text='Organisation Contact Information' className='text-[#004878] text-md font-bold' />
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <ParagraphComp text='Website' className='text-[#004878] text-md font-bold w-40' />
                      <a href={summaryData?.website_url} target='_blank' className='text-[#004878] text-md font-normal' >: {summaryData?.website_url}</a>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 1 }}>
                      <ParagraphComp text='Email Id' className='text-[#004878] text-md font-bold w-40' />
                      <Box sx={{ display: 'flex', gap: '4px' }}>
                        <ParagraphComp text={`: `} className='text-[#004878] cursor-pointer text-md font-normal' />
                        <ParagraphComp onClick={() => { viewEmail(summaryData?.primary_email) }} text={`${isViewEmail?.[summaryData?.primary_email] ? convertEmail(summaryData?.primary_email) : summaryData?.primary_email ? ' View' : '-'}`} className='text-[#004878] cursor-pointer underline text-md font-normal' />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 1 }}>
                      <ParagraphComp text='Contact Number' className='text-[#004878] text-md font-bold w-40' />
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        {Array.isArray(summaryData?.contact_number) && summaryData?.contact_number?.map((contact, index) => (
                          <ParagraphComp
                            key={index}
                            text={`: +${contact.country_code || '-'}-${contact.area_code ? `${contact.area_code}-` : '' || ''}${contact.phone_no || '-'}`}
                            className='text-[#004878] text-md font-normal'
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Box sx={{ width: '150px' }}>
                        <ParagraphComp text='Head Of Organization' className='text-[#004878] text-md font-bold ' />
                      </Box>
                      <Box sx={{ width: '50%' }}>
                        <ParagraphComp text={`: ${summaryData?.head_of_organisation || '-'}`} className='text-[#004878] text-md font-normal' />
                      </Box>
                    </Box>

                    <ParagraphComp text="Contact Person's Details" className='text-[#004878] text-md font-bold mt-3' />
                    <Box sx={{ display: 'flex', mt: 1 }}>
                      <ParagraphComp text='Name' className='text-[#004878] text-md font-bold w-40' />
                      <ParagraphComp text={`: ${summaryData?.contact_person_name || '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                    <Box sx={{ display: 'flex', mt: .5 }}>
                      <ParagraphComp text='Email Id' className='text-[#004878] text-md font-bold w-40' />
                      <Box sx={{ display: 'flex', gap: '4px' }}>
                        <ParagraphComp text={`: `} className='text-[#004878] cursor-pointer text-md font-normal' />
                        <ParagraphComp onClick={() => { viewEmail1(summaryData?.contact_person_email) }} text={`${isViewEmail1?.[summaryData?.contact_person_email] ? convertEmail(summaryData?.contact_person_email) : summaryData?.contact_person_email ? 'View' : '-'}`} className='text-[#004878] cursor-pointer underline text-md font-normal' />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', mt: .5 }}>
                      <ParagraphComp text='Phone' className='text-[#004878] text-md font-bold w-40' />
                      <ParagraphComp text={`: ${summaryData?.contact_person_telephone ? ` ${summaryData?.telephone_country_code ? `+${summaryData.telephone_country_code}` : '-'}-${summaryData?.contact_person_telephone ? summaryData?.telephone_area_code : '-'}-${summaryData?.contact_person_telephone ? summaryData?.contact_person_telephone : '-'}` : '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                    <Box sx={{ display: 'flex', mt: .5 }}>
                      <ParagraphComp text='Mobile Number' className='text-[#004878] text-md font-bold w-40' />
                      <ParagraphComp text={`: ${summaryData?.contact_person_mobile_no ? `+${summaryData?.mobile_country_code}` : '-'}-${summaryData?.contact_person_mobile_no ? summaryData?.contact_person_mobile_no : '-'}`} className='text-[#004878] text-md font-normal' />
                    </Box>
                  </Box>
                </Grid>

                <Grid sx={{ height: 'auto' }} item xs={5} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Box sx={{ width: '35%' }}>
                        <ParagraphComp text='PAN' className='text-[#004878] text-md font-bold ' />
                      </Box>
                      <Box sx={{ width: '60%' }}>
                        <ParagraphComp text={`: ${summaryData?.pan || '-'}`} className='text-[#004878] text-md font-normal' />
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Box sx={{ width: '35%' }}>
                        <ParagraphComp text='Darpan ID' className='text-[#004878] text-md font-bold' />
                      </Box>
                      <Box sx={{ width: '65%' }}>
                        <ParagraphComp text={`: ${summaryData?.darpan || '-'}`} className='text-[#004878] text-md font-normal' />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Box sx={{ width: '35%' }}>
                        <ParagraphComp text='FCRA Registration No' className='text-[#004878] text-md font-bold' />
                      </Box>
                      <Box sx={{ width: '65%' }}>
                        <ParagraphComp text={`: ${summaryData?.foreign_fund_number || '-'}`} className='text-[#004878] text-md font-normal' />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Box sx={{ width: '35%' }}>
                        <ParagraphComp text='Registered Address' className='text-[#004878] text-md font-bold ' />
                      </Box>
                      <Box sx={{ width: '65%' }}>
                        <ParagraphComp text={`: ${summaryData?.reg_room_no ? `${summaryData?.reg_room_no.replace(/,\s*$/, '')},` : ''} ${summaryData?.reg_street ? `${summaryData?.reg_street.replace(/,\s*$/, '')},` : ''} ${summaryData?.reg_city ? `${summaryData?.reg_city.replace(/,\s*$/, '')},` : ''} ${summaryData?.reg_district ? `${summaryData?.reg_district.replace(/,\s*$/, '')},` : ''} ${summaryData?.reg_state ? `${summaryData?.reg_state.replace(/,\s*$/, '')},` : ''} ${summaryData?.reg_pincode ? `${summaryData?.reg_pincode.replace(/,\s*$/, '')}` : ''}`} className='text-[#004878] text-md font-normal' />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 2 }}>
                      <Box sx={{ width: '35%' }}>
                        <ParagraphComp text='Correspondence Address' className='text-[#004878] text-md font-bold ' />
                      </Box>
                      <Box sx={{ width: '65%' }}>
                        <ParagraphComp text={`: ${summaryData?.cor_room_no ? `${summaryData?.cor_room_no.replace(/,\s*$/, '')},` : ''} ${summaryData?.cor_street ? `${summaryData?.cor_street.replace(/,\s*$/, '')},` : ''} ${summaryData?.cor_city ? `${summaryData?.cor_city.replace(/,\s*$/, '')},` : ''} ${summaryData?.cor_district ? `${summaryData?.cor_district.replace(/,\s*$/, '')},` : ''} ${summaryData?.cor_state ? `${summaryData?.cor_state.replace(/,\s*$/, '')},` : ''} ${summaryData?.cor_pincode ? `${summaryData?.cor_pincode.replace(/,\s*$/, '')}` : ''} `} className='text-[#004878] text-md font-normal' />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid sx={{ height: 'auto' }} item xs={3} >
                  <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', height: '100%' }}>
                    {renderSocial(meta, 'Facebook/ Instagram', summaryData?.social_media_facebook)}
                    {/* {renderSocial(instagram, 'Instagram', summaryData?.social_media_twitter)} */}
                    {renderSocial(linkedin, 'LinkedIn', summaryData?.social_media_linkedin)}
                    {renderSocial(twitter, 'Twitter', summaryData?.social_media_twitter)}
                    {renderSocial(youtube, 'Youtube', summaryData?.social_media_youtube)}
                  </Box>
                </Grid>
              </Grid>
              {summaryData?.future_we_envision &&
                <Box sx={{ mt: 7, width: '100%' }}>
                  <ParagraphComp text='What is the future we envision' className='text-[#004878] text-2xl mb-2 font-bold' />
                  <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                  <ParagraphComp text={summaryData?.future_we_envision || '-'} className='text-md mt-2 text-black text-justify' />
                </Box>
              }
              {summaryData?.aim_to_solve &&
                <Box sx={{ mt: 3, width: '100%' }}>
                  <ParagraphComp text='What we aim to solve' className='text-[#004878] text-2xl mb-2 font-bold' />
                  <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                  <ParagraphComp text={summaryData?.aim_to_solve || '-'} className='text-md mt-2 text-black text-justify' />
                </Box>
              }

              <Box sx={{ mt: 3, width: '100%' }}>
                <ParagraphComp text='What we do' className='text-[#004878] text-2xl mb-2 font-bold' />
                <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                <ParagraphComp text={`We started our organisation in the year ${summaryData?.registration_year} and since then served ${(summaryData?.segment_served || summaryData?.segment_served !== null) ? ` ${summaryData?.total_lives_changed ? `${summaryData?.total_lives_changed} number(s) of` : ''}${summaryData?.segment_served ? `${summaryData?.segment_served}` : ''}` : ''} ${(Array.isArray(summaryData?.causes) && summaryData?.causes.length > 0) ? (
                  ` in the thematic area(s) of ${summaryData?.causes
                    .map(ele => ele?.data)
                    .filter(Boolean)
                    .join(', ')} `
                ) : ''} ${(summaryData?.pan_india === 'Yes' || summaryData?.where_we_work_district) ? `in ${(summaryData?.pan_india === 'Yes' && summaryData?.where_we_work_district === false) ? '' : `${summaryData?.where_we_work_district}`}  ${summaryData?.pan_india === 'Yes' ? 'and pan India' : ''} ${summaryData?.key_indicator ? `and use the key indicator(s): ${summaryData?.key_indicator} ${summaryData?.verified ? `to track our progress, ${summaryData?.verified}` : ''}` : ''}` : ''} ${summaryData?.end_goal ? `and hope to reach our goal of ${summaryData?.end_goal}` : ''} ${summaryData?.end_goal_year ? `by around the year ${summaryData?.end_goal_year}.` : '.'}`} className='text-md mt-2 text-black text-justify' />
              </Box>

              {summaryData?.leaders_quotes || summaryData?.leaders_quotes !== "undefined" ?
                < Box sx={{ mt: 3, width: '100%' }}>
                  <ParagraphComp text='Leader’s Quote ' className='text-[#004878] text-2xl mb-2 font-bold' />
                  <div className='flex gap-1'>
                    <ParagraphComp text={`Leader's Name `} className='text-[#004878] text-md mb-2 font-bold' />
                    <ParagraphComp text={`${summaryData?.leader_name || '-'}`} className='text-[#004878] text-md mb-2' />
                  </div>
                  <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                  <ParagraphComp text={summaryData?.leaders_quotes || '-'} className='text-md mt-2 text-black text-justify' />
                </Box>
                : ''
              }
              {summaryData?.history &&
                <Box sx={{ mt: 3, width: '100%', backgroundColor: '#EFF1F3', borderRadius: '16px', padding: '16px', ml: -2, mr: 0 }}>
                  <ParagraphComp text='Why and how was the organisation set up' className='text-[#004878] text-2xl mb-2 font-bold' />
                  <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                  <ParagraphComp text={summaryData?.history || '-'} className='text-md mt-2 text-black text-justify' />
                </Box>
              }
            </Grid>

          </Grid >
          <Grid container spacing={2} sx={{ mt: 4 }}>
            <Grid item xs={6}>
              <Box sx={{ width: '100%' }}>
                <ParagraphComp text='Where we work' className='text-[#004878] text-2xl mb-2 font-bold' />
                <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                  {/* <img src={mapImage} width={304} height={174} alt='logo' /> */}
                  <Box sx={{ position: 'relative', height: '420px', width: '400px' }} >
                    <NewMap
                      selectedState={CorrectState(summaryData?.where_we_work_states)}
                      PanIndia={summaryData?.pan_india === 'Yes' ? true : false}
                    />
                    <Box sx={{ position: 'absolute', width: '100%', bottom: 0, margin: 'auto', backgroundColor: 'white', zIndex: 50 }} >
                      <ParagraphComp text={'Disclaimer: Map of India may not be to scale and is only for illustration purposes.'} className="text-[#004878] text-sm" />
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5, paddingTop: '40px' }}>
                    <Box>
                      <ParagraphComp text='Works pan India:' className='text-[#004878] text-md mb-1 font-bold' />
                      <ParagraphComp text={summaryData?.pan_india || '-'} className="text-[#004878] text-md" />
                    </Box>
                    <Box>
                      <ParagraphComp text='Key State(s):' className='text-[#004878] text-md mb-1 font-bold' />
                      {summaryData?.where_we_work_states?.includes(",")
                        ? summaryData?.where_we_work_states?.split(", ").map((item, i) =>
                          <ParagraphComp text={`${item}`} className="text-[#004878] text-md" />
                        )
                        : <ParagraphComp text={`${summaryData?.where_we_work_states}`} className="text-[#004878] text-md" />
                      }
                    </Box>
                    <Box >
                      <ParagraphComp text='Geographical focus:' className='text-[#004878] text-md mb-1 font-bold' />
                      {summaryData?.geographical_focus_of_activity?.includes(",")
                        ? summaryData?.geographical_focus_of_activity?.split(", ").map((item, i) =>
                          <ParagraphComp text={`${item}`} className="text-[#004878] text-md" />
                        )
                        : <ParagraphComp text={summaryData?.geographical_focus_of_activity ? `${summaryData?.geographical_focus_of_activity}` : '-'} className="text-[#004878] text-md" />
                      }
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <ParagraphComp text='See what we do' className='text-[#004878] text-2xl mb-2 font-bold' />
              <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
              <ParagraphComp text='One picture that tells the story of what the organisation does' className='text-md mt-2 mb-2 text-black' />
              {summaryData?.story && <img src={`data:image/png;base64,${summaryData?.story}`} className='h-[300px] max-h-[300px] object-cover max-w-[100%]' style={{ borderRadius: 12 }} alt='logo' />}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <Box sx={{ width: '100%' }}>
                <ParagraphComp text='Organisation’s Capabilities & Advantages' className='text-[#004878] text-2xl mb-2 font-bold' />
                <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                <ParagraphComp text={summaryData?.organisation_capabilities || '-'} className='text-md mt-2 text-black text-justify' />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ width: '100%' }}>
                <ParagraphComp text='Challenges' className='text-[#004878] text-2xl mb-2 font-bold' />
                <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                <ParagraphComp text={summaryData?.challenges || '-'} className='text-md mt-2 text-black' />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} id="involved">
              <Box sx={{ width: '100%', backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px' }}>
                <Box sx={{ display: 'flex', gap: '4px' }}>
                  <ParagraphComp text='Get Involved - ' className='text-[#d0353c] text-2xl font-bold cursor-pointer' />
                  <ParagraphComp text=' How you can make a difference' className='text-[#004878] text-2xl mb-2 font-bold' />
                </Box>
                <ParagraphComp text='*SOURCE: Self-reported by the organisation' className='text-[black] italic font-thin text-md' />
                <ParagraphComp text='Last updated on:' className='text-[black] font-bold text-md' />
                {summaryData?.trust_and_transparency_level !== "Claim your profile" ?
                  <Grid container spacing={2} xs={12}>
                    {(summaryData?.trust_and_transparency_level !== 'Entry Level') &&
                      <Grid item sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', borderRight: '1px solid #0000008a' }} xs={4}>
                        <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, mt: 2 }}>
                          <Box sx={{ height: '70px', borderRadius: '100%', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', flexShrink: 0 }}>
                            <img src={`data:image/png;base64,${summaryData?.give_money_icon}`} width={48} height={48} style={{ flexShrink: 0 }} alt='logo' />
                          </Box>
                          <Box>
                            <ParagraphComp text={'Give money'} className='text-[#004878] text-2xl font-bold' />
                            <ParagraphComp className='text-lg mt-2 text-[#004878] leading-normal' >

                              <span>Put to use your precious funds to address needs identified by the organisation!</span> <br />
                              <span>What we need: {summaryData?.make_a_difference ? summaryData?.make_a_difference : '-'}</span> <br />
                              {summaryData?.give_money_email ? <span>
                                To support {summaryData?.give_money_program_name}
                                {summaryData?.give_money_webpage ? <a href={`${summaryData?.give_money_webpage}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> click here </a> : ''}
                                {summaryData?.give_money_email ? 'or' : ''}
                                {summaryData?.give_money_email ? <a href={`mailto:${summaryData?.give_money_email}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> email</a> : ''}
                                {/* or email <a className='text-[#0697e6] cursor-pointer' href={summaryData?.give_money_webpage || '-'} target="_blank" rel="noopener noreferrer">
                                {summaryData?.give_money_webpage || '-'}
                              </a> */}
                              </span> :
                                <span></span>}
                            </ParagraphComp>
                          </Box>
                        </Box>
                        {/* <a onClick={() => { viewEmail(summaryData?.give_money_email) }} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer">
                                {isViewEmail?.[summaryData?.give_money_email] ? convertEmail(summaryData?.give_money_email) : summaryData?.give_money_email ? 'View' : '-'}
                              </a> */}

                      </Grid>
                    }
                    {summaryData?.trust_and_transparency_level !== 'Entry Level' &&
                      <Grid item sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', borderRight: '1px solid #0000008a' }} xs={4}>
                        <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, mt: 2 }}>
                          <Box sx={{ height: '70px', borderRadius: '100%', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', flexShrink: 0 }}>
                            <img src={`data:image/png;base64,${summaryData?.volunteer_icon}`} width={48} height={48} alt='logo' />
                          </Box>

                          <Box sx={{ width: '70%', color: '#004878' }}>

                            <ParagraphComp text='Volunteer' className='text-[#004878] text-2xl text-md font-bold' />
                            <ParagraphComp text={`Give your time and talent to engage with the cause or community you care about!`} className='text-lg mt-2 text-[#004878] leading-normal' />
                            <span>Opportunity(ies): {summaryData?.volunteer_cause ? summaryData?.volunteer_cause : '-'}</span> <br />
                            {summaryData?.volunteer_email && <ParagraphComp className='text-lg text-[#004878]' >
                              <ParagraphComp text={`Give your talent and time for a ${summaryData?.volunteer_cause}.`} className='text-lg mt-2 text-[#004878] leading-normal' />
                              To learn more,
                              {/* click here <a className='text-[#0697e6] cursor-pointer' onClick={() => { viewEmail(summaryData?.volunteer_email) }}>  {isViewEmail?.[summaryData?.volunteer_email] ? convertEmail(summaryData?.volunteer_email) : summaryData?.volunteer_email ? 'View' : '-'} </a> or email  <a className='text-[#0697e6] cursor-pointer' href={summaryData?.volunteer_webpage}>{summaryData?.volunteer_webpage || '-'}</a> */}
                              {summaryData?.volunteer_webpage ? <a href={`${summaryData?.volunteer_webpage}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> click here </a> : ''}
                              {summaryData?.volunteer_email ? 'or' : ''}
                              {summaryData?.volunteer_email ? <a href={`mailto:${summaryData?.volunteer_email}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> email</a> : ''}
                            </ParagraphComp>}

                          </Box>
                        </Box>


                      </Grid>
                    }

                    <Grid item sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', borderRight: '1px solid #0000008a' }} xs={4}>
                      <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, mt: 2 }}>
                        <Box sx={{ height: '70px', borderRadius: '100%', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', flexShrink: 0 }}>
                          <img src={`data:image/png;base64,${summaryData?.gift_in_kind_icon}`} width={48} height={48} alt='logo' />
                        </Box>

                        <Box sx={{ width: '70%', color: '#004878' }}>
                          <ParagraphComp text='Gift in-kind' className='text-[#004878] text-2xl font-bold' />
                          <ParagraphComp text={'Gift articles of NPO’s need. You may buy new ones or gift pre-used articles in good condition.'} className='text-md mt-2 text-[#004878] leading-normal' />
                          <span>Item(s) needed: {Array.isArray(summaryData?.items) ? summaryData?.items?.map(ele => { return `${ele?.category} - ${ele?.products}` }).join(', ') : '-'}</span> <br />
                          {summaryData?.gift_in_kind_email && <ParagraphComp className="text-lg mt-2 text-[#004878] leading-normal">
                            To make your gift,
                            {summaryData?.gift_in_kind_webpage ? <a href={`${summaryData?.gift_in_kind_webpage}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> click here </a> : ''}
                            {summaryData?.gift_in_kind_email ? 'or' : ''}
                            {summaryData?.gift_in_kind_email ? <a href={`mailto:${summaryData?.gift_in_kind_email}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> email</a> : ''}
                            {/* <a className='text-[#0697e6] cursor-pointer' onClick={() => { viewEmail(summaryData?.gift_in_kind_email) }} >  {isViewEmail?.[summaryData?.gift_in_kind_email] ? convertEmail(summaryData?.gift_in_kind_email) : summaryData?.gift_in_kind_email ? 'View' : '-'} </a> or email 
                          <a className='text-[#0697e6] cursor-pointer' href={summaryData?.gift_in_kind_webpage}> {summaryData?.gift_in_kind_webpage || '-'}</a>  */}
                          </ParagraphComp>}
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', borderRight: '1px solid #0000008a' }} xs={4}>
                      <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, mt: 2 }}>
                        <Box sx={{ height: '70px', borderRadius: '100%', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', flexShrink: 0 }}>
                          <img src={`data:image/png;base64,${summaryData?.purchase_icon}`} width={48} height={48} alt='logo' />
                        </Box>

                        <Box sx={{ width: '70%', color: '#004878' }}>
                          <ParagraphComp text='Purchase' className='text-[#004878]  text-2xl font-bold' />
                          <ParagraphComp text={'When you buy a product from an NPO, you change one or more lives!'} className='text-lg mt-2 text-[#004878] leading-normal' />
                          <ParagraphComp className='text-lg mt-2 text-[#004878] leading-normal' >
                            Item(s): {summaryData?.purchase_article1 ? `${summaryData?.purchase_article1}, ` : '-'}{summaryData?.purchase_article2 ? `${summaryData?.purchase_article2}, ` : ''}{summaryData?.purchase_article3 ? `${summaryData?.purchase_article3}, ` : ''}
                          </ParagraphComp>
                          {summaryData?.purchase_email && <ParagraphComp className='text-lg mt-2 text-[#004878] leading-normal' >
                            To buy from the org,
                            {summaryData?.purchase_webpage ? <a href={`${summaryData?.purchase_webpage}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> click here </a> : ''}
                            {summaryData?.purchase_email ? 'or' : ''}
                            {summaryData?.purchase_email ? <a href={`mailto:${summaryData?.purchase_email}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> email</a> : ''}
                            {/* <a className='text-[#0697e6] cursor-pointer' onClick={() => { viewEmail(summaryData?.purchase_email) }}>  {isViewEmail?.[summaryData?.purchase_email] ? convertEmail(summaryData?.purchase_email) : summaryData?.purchase_email ? 'View' : '-'}</a> or email <a className='text-[#0697e6] cursor-pointer' href={summaryData?.purchase_webpage || '-'}>{summaryData?.purchase_webpage || '-'}</a> */}
                          </ParagraphComp>}
                        </Box>
                      </Box>
                    </Grid>


                    <Grid item sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', borderRight: '1px solid #0000008a' }} xs={4}>
                      <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, mt: 2 }}>
                        <Box sx={{ height: '70px', borderRadius: '100%', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', flexShrink: 0 }}>
                          <img src={`data:image/png;base64,${summaryData?.celebrate_icon}`} width={48} height={48} alt='logo' />
                        </Box>

                        <Box sx={{ width: '70%' }}>
                          <ParagraphComp text='Celebrate Occasions/ Events/ Visit)' className='text-[#004878] text-2xl font-bold' />
                          <ParagraphComp text={'Make your special days memorable by sharing your joy with communities!'} className='text-md mt-2 text-[#004878] leading-normal' />
                          <ParagraphComp className='text-lg mt-2 text-[#004878] leading-normal' >
                            Details: {summaryData?.celebrate_event || '-'}
                          </ParagraphComp>
                          {summaryData?.celebrate_email && <ParagraphComp className='text-lg mt-2 text-[#004878] leading-normal' >
                            To learn more ,
                            {summaryData?.celebrate_webpage ? <a href={`${summaryData?.celebrate_webpage}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> click here </a> : ''}
                            {summaryData?.celebrate_email ? 'or' : ''}
                            {summaryData?.celebrate_email ? <a href={`mailto:${summaryData?.celebrate_email}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> email</a> : ''}
                            {/* click here or <a className='text-[#0697e6] cursor-pointer' onClick={() => { viewEmail(summaryData?.celebrate_email) }}>  {isViewEmail?.[summaryData?.celebrate_email] ? convertEmail(summaryData?.celebrate_email) : summaryData?.celebrate_email ? 'View' : '-'}</a>  or email <a className='text-[#0697e6] cursor-pointer' href={summaryData?.celebrate_webpage || '-'}>{summaryData?.celebrate_webpage || '-'}</a> */}
                          </ParagraphComp>}
                        </Box>
                      </Box>

                    </Grid>

                    {/* </Grid> */}
                    {/* <Grid sx={{ mt: '20px' }} container spacing={2} xs={12}> */}


                    <Grid item sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', borderRight: '1px solid #0000008a' }} xs={4}>
                      <Box sx={{ display: 'flex', alignItems: 'start', gap: 1, mt: 2 }}>
                        <Box sx={{ height: '70px', borderRadius: '100%', width: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', flexShrink: 0 }}>
                          <img src={`data:image/png;base64,${summaryData?.participate_in_icon}`} width={48} height={48} alt='logo' />
                        </Box>
                        <Box sx={{ width: '70%' }}>
                          <ParagraphComp text='Participate in' className='text-[#004878] text-2xl font-bold' />
                          <ParagraphComp text='Participate in events and campaigns to make your contribution make a bigger difference!' className='text-md mt-2 text-[#004878] leading-normal' />
                          <ParagraphComp className='text-lg mt-2 text-[#004878] leading-normal' >
                            Details: {summaryData?.participate_make_difference ? summaryData?.participate_make_difference : '-'}
                          </ParagraphComp>
                          {summaryData?.participate_email ? <ParagraphComp className='text-lg mt-2 leading-normal text-[#004878]' >
                            To learn how you can participate in,
                            {summaryData?.participate_webpage ? <a href={`${summaryData?.participate_webpage}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> click here </a> : ''}
                            {summaryData?.participate_email ? 'or' : ''}
                            {summaryData?.participate_email ? <a href={`mailto:${summaryData?.participate_email}`} className='text-[#0697e6] cursor-pointer' target="_blank" rel="noopener noreferrer"> email</a> : ''}
                            {/* {summaryData?.participate_make_difference} participate in {summaryData?.participate_campaign_name}, click <a className='text-[#0697e6] cursor-pointer' onClick={() => { viewEmail(summaryData?.participate_email) }}>  {isViewEmail?.[summaryData?.participate_email] ? convertEmail(summaryData?.participate_email) : summaryData?.participate_email ? 'View' : '-'}</a> or email <a className='text-[#0697e6] cursor-pointer' href={summaryData?.participate_webpage || '-'}>{summaryData?.participate_webpage || '-'}</a>  */}
                          </ParagraphComp> :
                            <ParagraphComp text={''} className='text-md mt-2 text-[#004878] leading-normal' />
                          }
                          {/* <ParagraphComp text={'Event or visit details in a sentence. To learn more link (email or web page)'} className='text-md mt-2 text-[#004878] leading-normal' /> */}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid> :
                  <ParagraphComp text={'Not applicable, yet to qualify for support'} className='text-md mt-4 pr-5' />
                }
                <ParagraphComp text={'*GuideStar India is only presenting information shared by the organisation without any verification. You would be transacting with the organisation or its intermediaries and using their payment channels as per their terms and conditions.'} className='text-md mt-4 text-[#004878] pr-5' />
              </Box>
            </Grid>
          </Grid>
          {summaryData?.collaboration_government ||
            summaryData?.collaboration_coorporates ||
            summaryData?.collaboration_npo ||
            summaryData?.network1 ||
            summaryData?.network2 ||
            summaryData?.network3 ?

            <Grid item xs={12} sx={{ marginTop: '20px' }}>
              <Box sx={{ width: '100%', borderRadius: '16px', padding: '16px', border: '.5px solid #004878' }}>
                <ParagraphComp text='Collaborations' className='text-[#004878] text-2xl mb-2 font-bold' />
                <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                <Box sx={{ mt: 1 }}>
                  <ParagraphComp text='with Government:' className='text-black text-md ' />
                  <ParagraphComp text={summaryData?.collaboration_government || '-'} className='text-md mt-2 text-[#004878]' />
                </Box>
                <Box sx={{ mt: 1 }}>
                  <ParagraphComp text='with Corporates:' className='text-black text-md ' />
                  <ParagraphComp text={summaryData?.collaboration_coorporates || '-'} className='text-md mt-2 text-[#004878]' />
                </Box>
                <Box sx={{ mt: 1 }}>
                  <ParagraphComp text='with NPOs:' className='text-black text-md ' />
                  <ParagraphComp text={summaryData?.collaboration_npo || '-'} className='text-md mt-2 text-[#004878]' />
                </Box>
                <ParagraphComp text='Networks' className='text-[#004878] text-2xl mb-2 mt-3 font-bold' />
                <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                <Box sx={{ mt: 1 }}>
                  <ParagraphComp text='Member of:' className='text-black text-md ' />

                  {/* <ParagraphComp text='Networks' className='text-black text-md font-bold' /> */}
                  <ParagraphComp text={` ${summaryData?.network1 ?? ''}`} className='text-md mt-2 text-[#004878]' />
                  <ParagraphComp text={` ${summaryData?.network2 ?? ''}`} className='text-md mt-2 text-[#004878]' />
                  <ParagraphComp text={` ${summaryData?.network3 ?? ''}`} className='text-md mt-2 text-[#004878]' />
                </Box>
              </Box>
            </Grid>
            : ''
          }

        </div >
        :
        < ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
      }
    </>
  )
}

export default Summary
